import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const CopyContext = createContext(null);

const FALLBACK = {
  "landing.eyebrow": "A standard, friendly calendar for the people you share life with",
  "landing.headline": "Born Day keeps every birthday, milestone, and plan in one place.",
  "landing.subhead": "Add the birthdays you don't want to miss. Plan parties, trips, and home gatherings. Track who's bringing what.",
  "landing.cta_primary": "Get started",
  "landing.cta_secondary": "I already have an account",
  "landing.cta_bottom_title": "One sign-up. The whole family in sync.",
  "landing.cta_bottom_button": "Create your account",
  "onboarding.headline": "Thank you for using the Born Day app.",
  "onboarding.body": "I'm adding birthdays to my calendar. I want to make sure that I never miss another birthday. Please share yours here.",
  "onboarding.skip_label": "Maybe later",
  "onboarding.save_label": "Save my birthday",
  "dashboard.title": "Your calendar",
  "dashboard.subtitle": "Every day. Every person. All in one place.",
  "dashboard.empty_state": "You haven't added anything yet. Start by adding your birthday or creating a group.",
  "dashboard.add_birthday_card_title": "Add your birthday",
  "dashboard.add_birthday_card_body": "Share your birthday once so the people in your groups never miss it.",
};

export const CopyProvider = ({ children }) => {
  const { user } = useAuth();
  const [copy, setCopy] = useState(FALLBACK);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/cms");
      setCopy({ ...FALLBACK, ...data });
    } catch {
      setCopy(FALLBACK);
    }
  }, []);

  useEffect(() => { load(); }, [load, user]);

  const t = useCallback((key, fallback) => copy[key] || fallback || key, [copy]);

  return (
    <CopyContext.Provider value={{ copy, t, refresh: load }}>
      {children}
    </CopyContext.Provider>
  );
};

export const useCopy = () => useContext(CopyContext) || { t: (k, f) => FALLBACK[k] || f || k, copy: FALLBACK, refresh: () => {} };
